import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  Home,
  Planos,
  MinhaConta,
  Footer,
  CardHome,
  CardPlanosResidenciais,
  PlanosResidenciais,
  PlanosEmpresariais,
  TiposDePagamentos,
  PaginaNaoEncontrada,
  TermosDeUso,
  PagamentoEmola,
  HistoricoPagammento,
  Login,
  PagamentoResidencia,
  PagamentoEmpresa,
  PagamentoViaMpesa,
  Recibo,
  Admin,
  RecibosUsuario,
  Clientes,
  DetalhesUsuario,
  AdicionarClientes,
  QuemSomos,
  Ajuda,
  Loading,
  Bloqueado,
  Funcionarios,
} from './Pages'; // Importação simplificada
import { AuthProvider } from './Contexts/AuthContext';
import RotaProtegida from './Pages/RotaProtegida';
import TaxaInstalacao from "./Pages/TaxaInstalacao";
import EstadoClientes from "./Pages/EstadoClientes";
import ClientesAtivos from "./Pages/ClientesAtivos";
import ClientesDesativos from "./Pages/ClientesDesativos";
import ReciboUsuarioCliente from "./Pages/ReciboUsuarioCliente";
import VariedadeplanosResidenciais from "./Pages/VariedadePlanosResidenciais";
import VariedadeplanosEmpresariais from "./Pages/VariedadePlanosEmpresariais";
import PlanosEmpresaTrimestre from "./Pages/PlanosEmpresaTrimestre";
import PlanosResidenciaTrimestre from "./Pages/PlanosResidenciaTrimestre";
import BroadCast from "./Pages/Broadcast";
import SuperAdmin from "./Pages/SuperAdmin";
import PagamentoResidenciaTrimestre from "./Pages/PagamentoResidenciaTrimestre";
import PagamentoEmpresaTrimestre from "./Pages/PagamentoEmpresaTrimestre";

function App() {
  return (
    <div>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Página de acesso bloqueado */}
            <Route path="/bloqueado" element={<Bloqueado />} />

            {/* Rota para login */}
            <Route path="/" element={<Login />} />
            {/* Rotas protegidas para usuários padrão */}
            <Route
              path="/home"
              element={
                <RotaProtegida tipoNecessario="">
                  <Home />
                </RotaProtegida>
              }
            />
            <Route
              path="/minhaconta"
              element={
                <RotaProtegida tipoNecessario="">
                  <MinhaConta />
                </RotaProtegida>
              }
            />

            <Route
              path="/recibos"
              element={
                <RotaProtegida tipoNecessario="">
                  <ReciboUsuarioCliente />
                </RotaProtegida>
              }
            />
            {/* Rotas protegidas para administradores */}
            <Route
              path="/admin"
              element={
                <RotaProtegida tipoNecessario={["admin", "super"]}>
                  <Admin />
                </RotaProtegida>
              }
            />
            <Route
              path="/admin/clientes"
              element={
                <RotaProtegida tipoNecessario={["admin", "super"]}>
                  <EstadoClientes />
                </RotaProtegida>
              }
            />
            <Route
              path="/admin/clientes/ativos"
              element={
                <RotaProtegida tipoNecessario={["admin", "super"]}>
                  <ClientesAtivos />
                </RotaProtegida>
              }
            />
            <Route
              path="/admin/clientes/desativos"
              element={
                <RotaProtegida tipoNecessario={["admin", "super"]}>
                  <ClientesDesativos />
                </RotaProtegida>
              }
            />
            <Route
              path="/admin/colaboradores"
              element={
                <RotaProtegida tipoNecessario={["admin", "super"]}>
                  <Funcionarios />
                </RotaProtegida>
              }
            />
            <Route
              path="/admin/broadcast"
              element={
                <RotaProtegida tipoNecessario={["admin", "super"]}>
                  <BroadCast />
                </RotaProtegida>
              }
            />
            <Route
              path="/admin/clientes/ativos/adicionarcliente/:id"
              element={
                <RotaProtegida tipoNecessario={["admin", "super"]}>
                  <AdicionarClientes />
                </RotaProtegida>
              }
            />
            <Route
              path="/admin/clientes/ativos/detalhesusuario/:id"
              element={
                <RotaProtegida tipoNecessario={["admin", "super"]}>
                  <DetalhesUsuario />
                </RotaProtegida>
              }
            />
            <Route
              path="/admin/clientes/ativos/recibosusuario/:id"
              element={
                <RotaProtegida tipoNecessario={["admin", "super"]}>
                  <RecibosUsuario />
                </RotaProtegida>
              }
            />
            <Route
              path="/admin/clientes/desativos/adicionarcliente/:id"
              element={
                <RotaProtegida tipoNecessario={["admin", "super"]}>
                  <AdicionarClientes />
                </RotaProtegida>
              }
            />
            <Route
              path="/admin/clientes/desativos/detalhesusuario/:id"
              element={
                <RotaProtegida tiposPermitidos={["admin", "super"]}>
                  <DetalhesUsuario />
                </RotaProtegida>
              }
            />

            <Route
              path="/admin/clientes/desativos/recibosusuario/:id"
              element={
                <RotaProtegida tipoNecessario="admin">
                  <RecibosUsuario />
                </RotaProtegida>
              }
            />

            {/* Outras rotas sem restrição */}
            <Route
              path="/planos"
              element={
                <RotaProtegida tipoNecessario="">
                  <Planos />
                </RotaProtegida>
              }
            />
            <Route
              path="/quemsomos"
              element={
                <RotaProtegida tipoNecessario="">
                  <QuemSomos />
                </RotaProtegida>
              }
            />
            <Route
              path="/ajuda"
              element={
                <RotaProtegida tipoNecessario="">
                  <Ajuda />
                </RotaProtegida>
              }
            />
            <Route path="/footer" element={<Footer />} />
            <Route path="/loading" element={<Loading />} />
            <Route path="/cardhome" element={<CardHome />} />
            <Route path="/cardplanosresidenciais" element={<CardPlanosResidenciais />} />
            <Route path="/taxainstalacao" element={<TaxaInstalacao />} />
            <Route
              path="/super"
              element={
                <RotaProtegida tipoNecessario="super">
                  <SuperAdmin />
                </RotaProtegida>
              }
            />
            <Route
              path="/planosresidenciais"
              element={
                <RotaProtegida tipoNecessario="">
                  <PlanosResidenciais />
                </RotaProtegida>
              }
            />
            <Route
              path="/variedadeplanosresidenciais"
              element={
                <RotaProtegida tipoNecessario="">
                  <VariedadeplanosResidenciais />
                </RotaProtegida>
              }
            />
            <Route
              path="/variedadeplanosempresariais"
              element={
                <RotaProtegida tipoNecessario="">
                  <VariedadeplanosEmpresariais />
                </RotaProtegida>
              }
            />
            <Route
              path="/planosempresariais"
              element={
                <RotaProtegida tipoNecessario="">
                  <PlanosEmpresariais />
                </RotaProtegida>
              }
            />
            <Route
              path="/tiposdepagamentos"
              element={
                <RotaProtegida tipoNecessario="">
                  <TiposDePagamentos />
                </RotaProtegida>
              }
            />
            <Route
              path="/planosempresariaistrimestrais"
              element={
                <RotaProtegida tipoNecessario="">
                  <PlanosEmpresaTrimestre />
                </RotaProtegida>
              }
            />
            <Route
              path="/planosresidenciaistrimestrais"
              element={
                <RotaProtegida tipoNecessario="">
                  <PlanosResidenciaTrimestre />
                </RotaProtegida>
              }
            />
            <Route
              path="/pagamentoviaemola"
              element={
                <RotaProtegida tipoNecessario="">
                  <PagamentoEmola />
                </RotaProtegida>
              }
            />
            <Route
              path="/historicopagamento"
              element={
                <RotaProtegida tipoNecessario="">
                  <HistoricoPagammento />
                </RotaProtegida>
              }
            />
            <Route
              path="/termosdeuso"
              element={
                <RotaProtegida tipoNecessario="">
                  <TermosDeUso />
                </RotaProtegida>
              }
            />
            <Route
              path="/planoresidencia/:id"
              element={
                <RotaProtegida tipoNecessario="">
                  <PagamentoResidencia />
                </RotaProtegida>
              }
            />
            <Route
              path="/residenciatrimestre/:id"
              element={
                <RotaProtegida tipoNecessario="">
                  <PagamentoResidenciaTrimestre />
                </RotaProtegida>
              }
            />
             <Route
              path="/empresatrimestre/:id"
              element={
                <RotaProtegida tipoNecessario="">
                  <PagamentoEmpresaTrimestre />
                </RotaProtegida>
              }
            />
            <Route
              path="/planoempresa/:id"
              element={
                <RotaProtegida tipoNecessario="">
                  <PagamentoEmpresa />
                </RotaProtegida>
              }
            />
            <Route
              path="/pagamentoviampesa"
              element={
                <RotaProtegida tipoNecessario="">
                  <PagamentoViaMpesa />
                </RotaProtegida>
              }
            />
            <Route
              path="/recibo/:id"
              element={
                <Recibo />
              }
            />

            {/* Rota de página não encontrada */}
            <Route path="*" element={<PaginaNaoEncontrada />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
